import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
const bonuses = [{
  n: '01',
  title: 'Plan Anti-Caos',
  text: 'Llegá a cada turno con todo listo.',
  price: '$8.000'
}, {
  n: '02',
  title: 'Banco de Casos Reales',
  text: '20 casos documentados para nunca improvisar.',
  price: '$10.000'
}, {
  n: '03',
  title: 'Kit Anti-Herradura',
  text: 'Los 5 errores más comunes y cómo corregirlos.',
  price: '$9.000'
}, {
  n: '04',
  title: 'Scripts de Consulta',
  text: '100+ frases para hablar, presentar y cerrar.',
  price: '$8.000'
}, {
  n: '05',
  title: 'Sistema Foto Premium',
  text: 'Tus trabajos vistos como merecen verse.',
  price: '$9.000'
}];
export function Bonuses() {
  return <section aria-label="Bonos incluidos" className="border-b border-ink-700 bg-ink-900 py-16 sm:py-20" data-id="element-18" data-mp="1mb9y16ll9sm0">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-19" data-mp="1r8te8c1ukfgl">
        <SectionHeading label="Bonos" title="🎁 5 bonos incluidos" data-id="element-20" data-mp="3idmyfw86v5fj" />

        <ul className="mt-10 grid gap-px bg-ink-700 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="3dfd2vkijy2te">
          {bonuses.map((bonus, i) => <motion.li key={bonus.n} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex flex-col justify-between gap-6 bg-ink-950 p-6" data-id="element-22" data-mp="3r79tfk4ko4no" data-mpi={i}>
              <div data-id="element-23" data-mp="2uikbjtsy3c1p">
                <span className="display text-xs tracking-[0.2em] text-ice" data-id="element-24" data-mp="38g8qkl0bzoyu">{bonus.n}</span>
                <h3 className="display mt-3 text-xl text-bone" data-id="element-25" data-mp="33h5mp3w37osg">{bonus.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ash" data-id="element-26" data-mp="33ja32lb6ag9m">{bonus.text}</p>
              </div>
              <p className="flex items-center gap-3 text-sm font-bold" data-id="element-27" data-mp="ns47u21lbu64">
                <span className="text-ash line-through" data-id="element-28" data-mp="iqexkom6zkj3">{bonus.price}</span>
                <span className="border border-ice px-2 py-0.5 text-xs uppercase tracking-widest text-ice" data-id="element-29" data-mp="3chv39kmwh2k0">
                  Gratis
                </span>
              </p>
            </motion.li>)}
        </ul>

        <p className="display mt-8 border border-ink-700 bg-ink-950 p-6 text-center text-xl text-bone sm:text-2xl" data-id="element-30" data-mp="3lk4dsai64vxe">
          Valor total: <span className="text-ash line-through" data-id="element-31" data-mp="3qgbmgb1y8lj1">$44.000</span> → gratis con tu pack
        </p>
      </div>
    </section>;
}